import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import { Globals } from "./constants";
import BackgroundImage from "react-background-image-loader";
import { Telco } from "./telco";
import { space2hyphen, space2hyphenForSlug } from "./HelperFunctions";

import { Carousel } from "react-responsive-carousel";

class Rightsection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videosPath:
        Globals.ApiUrl +
        "api/v1/user_api/home_videos?telco=" +
        this.props.telco +
        "&app_name=" +
        Globals.appName,
      storiesPath:
        Globals.ApiUrl +
        "api/stories?page=1&per_page=4&app_name=" +
        Globals.appName,
      videosApiResp: [],
      storiesResp: [],
    };
    this.getVideos = this.getVideos.bind(this);
  }

  async componentWillMount() {
    let url = this.state.videosPath,
      resp;

    try {
      resp = await Axios.get(url);
      if (resp.status == 200) {
        this.setState({ videosApiResp: resp.data.timeline_videos });
        // console.log('fetched latest videos', this.state.videosApiResp)
      } else {
        // console.log('error fetching latest videos!')
      }
    } catch (error) {
      console.log("error fetching latest videos");
    }

    this.getStoriesData();
  }

  async getStoriesData() {
    let resp;

    try {
      resp = await Axios.get(this.state.storiesPath);
      if (resp.status === 200) {
        this.setState({ storiesResp: resp.data.data });
        // console.log('fetched latest videos', this.state.videosApiResp)
      } else {
        // console.log('error fetching latest videos!')
      }
    } catch (error) {
      console.log("error fetching latest videos");
    }
  }

  getVideos() {
    return this.state.videosApiResp.map((video, i) => {
      return (
        <VideoCardSm
          key={"vcs-" + i}
          image={this.state.videosImage}
          data={video}
        />
      );
    });
  }

  getStories() {
    return this.state.storiesResp.map((story, i) => {
      return (
        <StoryCardSm
          key={"vcs-" + i}
          image={this.state.videosImage}
          data={story}
        />
      );
    });
  }

  render() {
    return (
      <div id="right-section" className="d-none d-lg-block jc-inner-page pl-4">
        <div className="card mt-2 p-3">
          <h4 className="font-weight-semi-bold border-bottom pb-2 text-uppercase">
            Video Highlights
          </h4>
          {this.getVideos()}
        </div>
        {Telco === "mobilink" ? (
          ""
        ) : (
          // <div className="card mt-2 p-3">
          //          <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner.jpg'} alt=""/>
          //      </div>
          <div
            className="card mt-2"
            style={{
              cursor: `pointer`,
            }}
            onClick={() =>
              window.open(
                `https://gago.games/digital/pk?utm_source=182&utm_medium=Banner1&utm_campaign=Cricwick`,
                `_blank`
              )
            }
          >
            <img
              src={
                "https://dtyw1lw4i4r2x.cloudfront.net/banners/GagoAd_CricwickPortal-02.png"
              }
              alt=""
            />
          </div>
        )}
        {/* {
            Telco === "mobilink"
            ?
            ""
            :
            // <div className="card mt-2 p-3">
            //          <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner.jpg'} alt=""/>
            //      </div>
            <Carousel className="mt-2" showIndicators={false} infiniteLoop={true} autoPlay={true} showArrows={false} showStatus={false} showThumbs={false}>  
                <div className="card">
                    <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner.jpg'} alt=""/>
                </div>
                <div className="card ">
                    <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner-1.png'} alt=""/>
                </div>
                <div className="card ">
                    <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner-2.png'} alt=""/>
                </div>
                <div className="card ">
                    <img src={'https://dtyw1lw4i4r2x.cloudfront.net/banners/Right-Side-Banner-3.png'} alt=""/>
                </div>
            </Carousel>
            
        } */}
        <div className="card mt-2 p-3">
          <div className="d-flex overflow-x-auto justify-content-between border-bottom align-items-center mb-2">
            <div>
              <h4 className="font-weight-semi-bold text-uppercase">Stories</h4>
            </div>
            <div>
              <Link to="/stories">
                <h6 className="font-weight-semi-bold text-uppercase">
                  View All
                </h6>
              </Link>
            </div>
          </div>
          {this.getStories()}
        </div>

        {/* <!--card--> */}

        {/* <!--card--> */}
        {/*<div className="card mt-2 p-3">
          <h4 className="font-weight-semi-bold border-bottom pb-2">Match Stats</h4>
          <SeriesStatsTable></SeriesStatsTable>
        </div>*/}
      </div>
    );
  }
}
const VideoCardDescription = (props) => (
  <div className="custom-clamp-text">
    <p className="text-secondary mb-0 font-weight-normal text-nowrap mb-1">
      {props.data.match_obj.title}
    </p>
    <h5 className="text-black mb-0 font-weight-normal flex-fill">
      {props.data.title}
    </h5>
  </div>
);

const StoryCardDescription = (props) => (
  <div className="custom-clamp-text">
    <p className="text-secondary mb-0 font-weight-normal text-nowrap mb-1">
      {props.data.series_name}
    </p>
    <h5 className="text-black mb-0 font-weight-normal flex-fill">
      {props.data.title}
    </h5>
  </div>
);

const VideoCardSm = (props) => (
  <div className="mb-2">
    <Link
      to={
        "/video/highlights/" +
        props.data.id +
        "/" +
        space2hyphenForSlug(props.data.title)
      }
      className="d-flex "
    >
      <div className="w-40 position-relative">
        {/* <div className="sixteen-by-nine bg-center-cover" style={{backgroundImage: 'url('+props.data.thumb+')'}}></div> */}
        <BackgroundImage
          className="sixteen-by-nine bg-center-cover"
          src={props.data.thumb}
          placeholder={Globals.placeholderPlain4x3}
        >
          <div className="fa fa-play-circle play-btn-lg play-btn-xs" />
        </BackgroundImage>
      </div>
      <div className="pl-2 video-card-right-section">
        <VideoCardDescription data={props.data} />
      </div>
    </Link>
  </div>
);

const StoryCardSm = (props) => (
  <div className="mb-2">
    <Link
      to={
        "/stories/" +
        props.data.id +
        "/" +
        space2hyphenForSlug(props.data.title)
      }
      className="d-flex "
    >
      <div className="w-40 position-relative">
        {/* <div className="sixteen-by-nine bg-center-cover" style={{backgroundImage: 'url('+props.data.thumb+')'}}></div> */}
        <BackgroundImage
          className="sixteen-by-nine bg-center-cover"
          src={props.data.image}
          placeholder={Globals.placeholderPlain4x3}
        />
      </div>
      <div className="pl-2 video-card-right-section">
        <StoryCardDescription data={props.data} />
      </div>
    </Link>
  </div>
);

const SeriesStatsTable = (props) => (
  <table className="mb-3">
    <tbody>
      <SeriesStatsTitle />
      <SeriesStatsRow />
      <SeriesStatsRow />
    </tbody>
  </table>
);

const SeriesStatsTitle = () => (
  <tr>
    <td
      valign="middle"
      className="text-uppercase w-50 font-weight-semi-bold py-2 px-1"
    >
      Most Runs
    </td>
    <td
      valign="middle"
      className="text-secondary font-weight-semi-bold py-2 px-1"
      align="center"
    >
      B
    </td>
    <td
      valign="middle"
      className="text-secondary font-weight-semi-bold py-2 px-1"
      align="center"
    >
      4s
    </td>
    <td
      valign="middle"
      className="text-secondary font-weight-semi-bold py-2 px-1"
      align="center"
    >
      6s
    </td>
    <td
      valign="middle"
      className="text-secondary font-weight-semi-bold py-2 px-1"
      align="center"
    >
      SR
    </td>
  </tr>
);

const SeriesStatsRow = (props) => (
  <tr>
    <td valign="middle" className="font-weight-normal px-1 py-1" align="left">
      Babar Azam
    </td>
    <td valign="middle" className="font-weight-normal px-1 py-1" align="center">
      140
    </td>
    <td valign="middle" className="font-weight-normal px-1 py-1" align="center">
      5
    </td>
    <td valign="middle" className="font-weight-normal px-1 py-1" align="center">
      5
    </td>
    <td valign="middle" className="font-weight-normal px-1 py-1" align="center">
      70.99
    </td>
  </tr>
);

export default Rightsection;
